export const CHAR_CODES = { ENTER: 13, DOWN: 40, UP: 38 };
